import { MediaPlayer, MediaProvider } from '@vidstack/react';
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from '@vidstack/react/player/layouts/default';

import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

import styles from './VideoPlayer.module.css';

const getStreamUrl = (src: string) => {
  return `${src}/hls/index.m3u8`;
};

type VideoPlayerProps = {
  src: string;
};

export const VideoPlayer = ({ src }: VideoPlayerProps) => {
  return (
    <MediaPlayer
      src={getStreamUrl(src)}
      crossOrigin
      className={styles.player}
      playsInline
      aspectRatio="16/9"
    >
      <MediaProvider />
      <DefaultVideoLayout icons={defaultLayoutIcons} />
    </MediaPlayer>
  );
};
